import { useSelector } from 'react-redux';

import { RootState } from 'store';

const useCompanyConfiguration = () => useSelector((state: RootState) => state.companyConfiguration.configuration);

export default useCompanyConfiguration;
